/**
 * ROUTE_SLUG_REG_EXP can be used to remove the routeSlug (/en-ae/.../.../)
 * from url's regardless of what country and language are selected at the moment
 */
export const ROUTE_SLUG_REG_EXP = new RegExp(
  "(/[\\w+]{2}-[\\w+]{2}(?=/))?",
  "gi"
);
